import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { UitkEventBarThemes, UitkEventBarTypes } from '../../../types.esm.js';
import styles from '../../../uitk-calendar.css';
var getClassNameList = classNames.bind(styles);
var UitkBarStyle = function (props) {
  var _a = props.theme,
    theme = _a === void 0 ? 'default' : _a,
    _b = props.type,
    type = _b === void 0 ? 'solid' : _b,
    _c = props.segment,
    segment = _c === void 0 ? 'start-end' : _c,
    children = props.children;
  var wrapperClassNames = getClassNameList('uitk-event-bar-item', "uitk-event-bar-item-segment-".concat(segment), UitkEventBarThemes.get(theme), UitkEventBarTypes.get(type));
  return React.createElement("div", {
    className: wrapperClassNames
  }, children);
};
UitkBarStyle.displayName = 'UitkBarStyle';
export { UitkBarStyle };